<template>
  <stat :title="$t('dashboard.gains.title')" :loading="loading">
    <gains-chart
      :dataKey="dataKey"
      :params="params"
      :height="200"
      style="width: 100%"></gains-chart>
  </stat>
</template>

<script>
  import { GainsChart } from '@/components/charts'
  import stats from '@/mixins/stats'
  export default {
    components: {
      GainsChart
    },
    mixins: [stats],
    props: {
      dataKey: {
        type: String,
        default: 'gains'
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/dashboard/Gains.vue